__turbopack_context__.v({
  "button": "TextButton-module-scss-module__edRXCG__button",
  "fade-in": "TextButton-module-scss-module__edRXCG__fade-in",
  "iconBackdrop": "TextButton-module-scss-module__edRXCG__iconBackdrop",
  "iconStart": "TextButton-module-scss-module__edRXCG__iconStart",
  "no-transform": "TextButton-module-scss-module__edRXCG__no-transform",
  "noShrink": "TextButton-module-scss-module__edRXCG__noShrink",
  "rotate": "TextButton-module-scss-module__edRXCG__rotate",
  "sizeMd": "TextButton-module-scss-module__edRXCG__sizeMd",
  "sizeSm": "TextButton-module-scss-module__edRXCG__sizeSm",
  "variantBrand": "TextButton-module-scss-module__edRXCG__variantBrand",
  "variantCritical": "TextButton-module-scss-module__edRXCG__variantCritical",
  "variantNoBg": "TextButton-module-scss-module__edRXCG__variantNoBg",
  "variantPrimary": "TextButton-module-scss-module__edRXCG__variantPrimary",
  "variantSecondary": "TextButton-module-scss-module__edRXCG__variantSecondary",
});
